import { type ForwardedRef, forwardRef, type InputHTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";
import { InputRoot } from "./InputRoot";
import { generatePlaceholder } from "./utils/generatePlaceholder";

export const InputTel = forwardRef(
  (
    props: InputHTMLAttributes<HTMLInputElement>,
    ref: ForwardedRef<HTMLInputElement>,
  ) => (
    <InputRoot
      ref={ref}
      {...props}
      type="tel"
      pattern="[0-9]{11}"
      className={twMerge("w-full", props.className)}
      placeholder={generatePlaceholder(props.placeholder ?? "02071207120")}
      autoComplete="tel"
    />
  ),
);

InputTel.displayName = "InputTel";
